import React from "react";
import { Camera, User, Activity, ChevronRight, ArrowLeftRight, RotateCcw } from "lucide-react";
import { useLang } from "../context/LangContext";

const REQ_IMG = "https://images.unsplash.com/photo-1614893228004-447f16ec6398?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwxfHxtYWxlJTIwZml0bmVzcyUyMG1vZGVsJTIwYWJzfGVufDB8fHx8MTc4MDkyNDAxMnww&ixlib=rb-4.1.0&q=85";

const photoIcons = [User, Activity, RotateCcw, ArrowLeftRight, RotateCcw];

export default function Requirements() {
  const { t } = useLang();
  return (
    <section id="requirements" data-testid="requirements-section" className="py-24 lg:py-32 bg-[#0a0a0a] relative">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
        <div className="lg:col-span-5">
          <div className="sticky top-28">
            <div className="img-hover aspect-[3/4] w-full">
              <img src={REQ_IMG} alt="Requirements" className="w-full h-full object-cover grayscale" />
            </div>
            <div className="mt-6 border-l-2 border-[#00E5FF] pl-4">
              <div className="label-eyebrow text-[#00E5FF]">{t.requirements.eyebrow}</div>
              <p className="font-display text-2xl text-white mt-1">
                {t.requirements.title}
              </p>
            </div>
          </div>
        </div>

        <div className="lg:col-span-7">
          <h2 className="font-display uppercase text-4xl sm:text-5xl lg:text-6xl tracking-tight text-white mb-6">
            {t.requirements.title}
          </h2>
          <p className="text-neutral-400 leading-relaxed mb-12 max-w-xl">{t.requirements.desc}</p>

          <div className="space-y-px bg-white/5 mb-16">
            {t.requirements.items.map((item, i) => (
              <div key={i} className="flex items-center justify-between bg-[#0a0a0a] py-6 px-2 hover:px-4 transition-all duration-300 group">
                <div className="flex items-center gap-6">
                  <span className="font-display text-[#00E5FF] text-sm w-8">0{i + 1}</span>
                  <span className="label-eyebrow text-neutral-500 w-24">{item.label}</span>
                </div>
                <span className="text-white text-base sm:text-lg font-light text-right">{item.value}</span>
              </div>
            ))}
          </div>

          <div className="border border-white/10 p-8 lg:p-10 bg-[#050505]">
            <div className="flex items-center gap-3 mb-8">
              <Camera size={18} className="text-[#00E5FF]" />
              <h3 className="font-display uppercase text-xl tracking-wider text-white">{t.requirements.photosTitle}</h3>
            </div>
            <div className="space-y-5">
              {t.requirements.photos.map((p, i) => {
                const Icon = photoIcons[i] || Camera;
                return (
                  <div key={i} className="flex items-start gap-5 group">
                    <div className="flex-shrink-0 w-10 h-10 border border-[#00E5FF]/30 flex items-center justify-center text-[#00E5FF] group-hover:bg-[#00E5FF] group-hover:text-black transition-all duration-300">
                      <Icon size={16} />
                    </div>
                    <div className="flex-1 pt-2">
                      <div className="text-neutral-300 leading-relaxed">{p}</div>
                    </div>
                    <ChevronRight size={16} className="text-neutral-600 mt-3 group-hover:text-[#00E5FF] transition-colors" />
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
